var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDolyami(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 20,
    viewBox: "0 0 68 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 20,
    rx: 4,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_353_12535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9392 6H14.6044V12.7689H15.9392V6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0711 6.37876H11.7363V13.1475H13.0711V6.37876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.203 6.80162H8.86814V13.5716H10.203V6.80162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33482 7.22917H6L6.00001 14H7.33482L7.33482 7.22917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1954 9.60607L49.0462 7.21646H47.7897V12.7492H49.1016V9.21922L51.0638 11.3106H51.3062L53.2347 9.21922V12.7492H54.5465V7.21646H53.2901L51.1954 9.60607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7965 7.21646L57.5449 10.8126V7.21646H56.2331V12.7492H57.4349L60.6865 9.15313V12.7492H61.9984V7.21646H60.7965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7237 9.24098C40.7237 10.1219 41.2054 10.8158 41.9448 11.1067L40.5583 12.7492H42.164L43.4253 11.255H44.7901V12.7492H46.102V7.21646H42.7621C41.5169 7.21646 40.7237 8.06834 40.7237 9.24098ZM44.7909 8.43504V10.0711H43.0054C42.4097 10.0711 42.0901 9.73905 42.0901 9.25226C42.0901 8.76548 42.4209 8.43343 43.0054 8.43343L44.7909 8.43504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6275 8.32302C34.5472 10.2258 34.1458 11.4541 33.3598 11.4541H33.1631V12.7823L33.3726 12.7936C34.9486 12.8814 35.8197 11.4984 35.9626 8.47776H38.0356V12.7492H39.3451V7.21646H34.6716L34.6275 8.32302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6892 7.13916C27.9149 7.13916 26.6383 8.36741 26.6383 9.98251C26.6383 11.6532 28.0273 12.838 29.6892 12.838C31.4201 12.838 32.7649 11.5871 32.7649 9.98251C32.7649 8.37789 31.4201 7.13916 29.6892 7.13916ZM29.6892 11.5098C28.6864 11.5098 28.0032 10.857 28.0032 9.98251C28.0032 9.08631 28.6872 8.45123 29.6892 8.45123C30.6912 8.45123 31.3977 9.11532 31.3977 9.98251C31.3977 10.8497 30.6815 11.5098 29.6892 11.5098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.247 7.2269H20.617L20.5728 8.33345C20.507 9.9276 20.0911 11.4436 19.3051 11.4653L18.9414 11.4766V13.9998L20.2645 13.9971V12.75H24.8609V13.9971H26.1952V11.4653H25.247V7.2269ZM23.9352 11.4653H21.1356C21.6093 10.7464 21.863 9.70597 21.9072 8.489H23.9352V11.4653Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_353_12535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 8,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolyami);
export default __webpack_public_path__ + "static/media/dolyami.f52c8ab5a7ac3c9e137677762071107b.svg";
export { ForwardRef as ReactComponent };